'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('../../extends-f8003900.js');
var slicedToArray = require('../../slicedToArray-e6d9072a.js');
var React = require('react');
var index = require('../../index-6ed9f31c.js');
var formik_esm = require('../../formik.esm-1c3621f3.js');
var components_Box_Box = require('../Box/Box.js');
var FormContext = require('../../FormContext-170b414c.js');
var validateField = require('../../validateField-179f14cb.js');
var components_FieldErrorMessage_FieldErrorMessage = require('../FieldErrorMessage/FieldErrorMessage.js');
var components_Typography_Typography = require('../Typography/Typography.js');
var utils_isType_isType = require('../../utils/isType/isType.js');
var xstyledStyledComponents_es = require('../../xstyled-styled-components.es-02f83f64.js');
var styles_themeUtils = require('../../styles/themeUtils.js');
var styles_breakpoints = require('../../breakpoints-7bb24b2d.js');
require('../../unsupportedIterableToArray-a6f9513d.js');
require('../../objectWithoutProperties-aa43106a.js');
require('../../xstyled-prop-types.es-7d7acd76.js');
require('../Image/Image.js');
require('../NuDSProvider/NuDSProvider.js');
require('../GlobalStyle/GlobalStyle.js');
require('styled-components');
require('../../theme-340a6118.js');
require('../../colorBuilder-0e3465cf.js');
require('../../polished.esm-0312677e.js');
require('../../utils/logger/logDeprecatedFeature/logDeprecatedFeature.js');
require('../../utils/env/isBrowserEnv/isBrowserEnv.js');
require('../../utils/env/isTestEnv/isTestEnv.js');
require('../../utils/env/isProdEnv/isProdEnv.js');
require('../../utils/string/isString.js');
require('../../styles/colors/colorVariantsShape.js');
require('../../utils/hooks/useIntlAriaAttrs.js');
require('../../utils/intl/intlAriaAttrs.js');
require('../../utils/i18n/maybeFormatPrefixedMessage.js');
require('../../utils/i18n/maybeFormatMessage.js');
require('../../defineProperty-3cad0327.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _templateObject$2, _templateObject2$1, _templateObject3, _templateObject4;
var checkMark = xstyledStyledComponents_es.css(_templateObject$2 || (_templateObject$2 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  :after {\n    border-radius: 50%;\n    width: 0.875rem;\n    height: 0.875rem;\n    \n    position: absolute;\n    left: 0.1875rem;\n    top: 0.1875rem;\n    box-sizing: border-box;\n    border: 0;\n    content: \" \";\n    display: block;\n    background: ", ";\n  }\n"])), styles_themeUtils.nuDSColor('primary'));
var defaultRadio = xstyledStyledComponents_es.css(_templateObject2$1 || (_templateObject2$1 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  display: flex;\n  cursor: pointer;\n  position: relative;\n  height: 1.25rem;\n  align-items: flex-end;\n  padding-left: calc(1.125rem + 1.125rem );\n  width: max-content;\n  margin-top: ", ";\n\n  &::before {\n    content: \" \";\n    position: absolute;\n    width: 1.125rem;\n    height: 1.125rem;\n    border: 1px solid;\n    border-color: ", ";\n    background-color: transparent;\n    border-radius: 50%;\n    left: 0;\n    top: 0;\n  }\n\n  &:hover, &:focus-within {\n    &::before {\n      border-color: ", ";\n    }\n  }\n\n  :first-of-type {\n    margin-top: 0;\n  }\n\n  :last-of-type {\n    margin-bottom: ", ";\n  }\n\n  ", "\n"])), styles_themeUtils.spacing('5x'), function (_ref) {
  var checked = _ref.checked;
  return checked ? styles_themeUtils.nuDSColor('primary') : styles_themeUtils.nuDSColor('black', 'defaultT70');
}, styles_themeUtils.nuDSColor('primary'), styles_themeUtils.spacing('4x'), function (_ref2) {
  var checked = _ref2.checked;
  return checked && checkMark;
});
var buttonRadio = xstyledStyledComponents_es.css(_templateObject3 || (_templateObject3 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding: ", ";\n  width: auto;\n  border: 1px solid;\n  border-color: ", ";\n  border-radius: 8px;\n\n  &:hover, &:focus-within {\n    border-color: ", ";\n  }\n"])), styles_themeUtils.spacing('4x'), function (_ref3) {
  var checked = _ref3.checked;
  return checked ? styles_themeUtils.nuDSColor('primary') : styles_themeUtils.nuDSColor('black', 'defaultT10');
}, styles_themeUtils.nuDSColor('primary'));
var styleTypeMapper = {
  "default": defaultRadio,
  button: buttonRadio
};
var Label = xstyledStyledComponents_es.styled.label(_templateObject4 || (_templateObject4 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  ", "\n"])), function (_ref4) {
  var styleType = _ref4.styleType;
  return styleTypeMapper[styleType];
});
Label.propTypes = {
  checked: index.PropTypes.bool,
  styleType: index.PropTypes.string
};
Label.defaultProps = {
  styleType: 'default',
  checked: false
};
Label.displayName = 'Label';

var _templateObject$1;
var RadioButtonInput = xstyledStyledComponents_es.styled.input(_templateObject$1 || (_templateObject$1 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  appearance: none;\n  opacity: 0;\n"])));
RadioButtonInput.defaultProps = {
  type: 'radio'
};
RadioButtonInput.displayName = 'RadioButtonInput';

var RadioButton = function RadioButton(_ref) {
  var name = _ref.name,
      value = _ref.value,
      LabelComponent = _ref.label,
      id = _ref.id,
      onChange = _ref.onChange,
      checked = _ref.checked,
      onBlur = _ref.onBlur,
      styleType = _ref.styleType,
      marginDirection = _ref.marginDirection;
  var labelId = "label-".concat(id, "-").concat(value);
  var inputId = "input-".concat(id, "-").concat(value);

  var LabelWrapper = function LabelWrapper(props) {
    return utils_isType_isType.isType('function', LabelComponent) ? /*#__PURE__*/React__default['default'].createElement(LabelComponent, props) : LabelComponent;
  };

  return /*#__PURE__*/React__default['default'].createElement(Label, {
    id: labelId,
    htmlFor: inputId,
    checked: checked,
    styleType: styleType,
    marginDirection: marginDirection
  }, /*#__PURE__*/React__default['default'].createElement(RadioButtonInput, {
    id: inputId,
    onChange: onChange,
    name: name,
    value: value,
    checked: checked,
    onBlur: onBlur
  }), /*#__PURE__*/React__default['default'].createElement(components_Typography_Typography['default'], {
    variant: "paragraph2",
    strong: true,
    tag: "span"
  }, /*#__PURE__*/React__default['default'].createElement(LabelWrapper, {
    checked: checked
  })));
};

RadioButton.defaultProps = {
  styleType: 'default',
  checked: false,
  marginDirection: 'vertical',
  onBlur: function onBlur() {},
  onChange: function onChange() {}
};
RadioButton.propTypes = {
  checked: index.PropTypes.bool,
  id: index.PropTypes.string.isRequired,
  label: index.PropTypes.node.isRequired,
  marginDirection: index.PropTypes.string,
  name: index.PropTypes.string.isRequired,
  onBlur: index.PropTypes.func,
  onChange: index.PropTypes.func,
  styleType: index.PropTypes.oneOf(['default', 'button']),
  value: index.PropTypes.string.isRequired
};
var RadioButton$1 = /*#__PURE__*/React__default['default'].memo(RadioButton);

var _templateObject, _templateObject2;
var Legend = xstyledStyledComponents_es.styled(components_Typography_Typography['default'])(_templateObject || (_templateObject = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  color: ", ";\n  margin-top: ", ";\n  margin-bottom: ", ";\n\n  ", "\n"])), styles_themeUtils.nuDSColor('black', 'defaultT70'), styles_themeUtils.spacing('4x'), styles_themeUtils.spacing('3x'), function (_ref) {
  var align = _ref.align;
  return align === 'horizontal' && styles_breakpoints.breakpointsMedia({
    md: xstyledStyledComponents_es.css(_templateObject2 || (_templateObject2 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n        display: flex;\n        align-items: center;\n        margin-top: 0;\n        margin-bottom: 0;\n        margin-right: ", ";\n      "])), styles_themeUtils.spacing('4x'))
  });
});
Legend.defaultProps = {
  variant: 'paragraph2',
  tag: 'legend',
  strong: true
};
Legend.displayName = 'Legend';

var RadioButtonGroup = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var align = _ref.align,
      label = _ref.label,
      className = _ref.className,
      name = _ref.name,
      id = _ref.id,
      options = _ref.options,
      syncValidations = _ref.syncValidations,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      styleType = _ref.styleType;
  var validations = FormContext.useFormValidations();

  var _useFormData = FormContext.useFormData(),
      formsValues = _useFormData.formsValues;

  var _useContext = React.useContext(formik_esm.FormikContext),
      values = _useContext.values;

  var errorMessageId = "error-".concat(name);
  var legendId = "legend-".concat(name);
  var currentValue = values[name];

  var _useField = formik_esm.useField({
    name: name,
    validate: validateField.validateField(validations, syncValidations, _extends._extends({}, formsValues, values))
  }),
      _useField2 = slicedToArray.slicedToArray(_useField, 2),
      field = _useField2[0],
      meta = _useField2[1];

  var hasError = Boolean(meta.error);

  var a11yProps = _extends._extends({
    'aria-required': Boolean(syncValidations.required),
    'aria-invalid': hasError,
    'aria-labelledby': legendId
  }, hasError && {
    'aria-describedby': errorMessageId
  });

  var handleOnChange = React.useCallback(function (event) {
    field.onChange(event);
    onChange(event);
  }, [field.onChange, onChange]);
  var handleOnBlur = React.useCallback(function (event) {
    field.onBlur(event);
    onBlur(event);
  }, [field.onBlur, onBlur]);
  return /*#__PURE__*/React__default['default'].createElement(components_Box_Box['default'], _extends._extends({
    ref: ref,
    className: className,
    component: "fieldset",
    id: legendId
  }, a11yProps, {
    display: "grid",
    gridColumnGap: "30px",
    gridRowGap: "1em",
    gridTemplateColumns: align === 'horizontal' ? 'repeat(auto-fit, minmax(250px, 1fr))' : '1fr'
  }), label && /*#__PURE__*/React__default['default'].createElement(Legend, {
    align: align
  }, label), options.map(function (option) {
    return /*#__PURE__*/React__default['default'].createElement(RadioButton$1, {
      key: option.value,
      id: id,
      name: name,
      label: option.label,
      value: option.value,
      onChange: handleOnChange,
      checked: option.value === currentValue,
      onBlur: handleOnBlur,
      styleType: styleType
    });
  }), /*#__PURE__*/React__default['default'].createElement(components_FieldErrorMessage_FieldErrorMessage['default'], {
    name: name,
    errorMessageId: errorMessageId
  }));
});
RadioButtonGroup.defaultProps = {
  align: 'vertical',
  className: undefined,
  label: undefined,
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  syncValidations: {},
  styleType: 'default'
};
RadioButtonGroup.propTypes = {
  /** The align property adjusts the directions of the buttons */
  align: index.PropTypes.oneOf(['horizontal', 'vertical']),

  /** The className property that will be applied to the HTML element */
  className: index.PropTypes.string,

  /** The id property that will be applied to the HTML element */
  id: index.PropTypes.string.isRequired,

  /** A property used as placeholder text and top label text */
  label: index.PropTypes.node,

  /** A name property to identify and match the field  */
  name: index.PropTypes.string.isRequired,

  /** The onBlur handler */
  onBlur: index.PropTypes.func,

  /** The onChange handler */
  onChange: index.PropTypes.func,

  /** The data needed to populate the radiobutton list */
  options: index.PropTypes.arrayOf(index.PropTypes.shape({
    label: index.PropTypes.node,
    value: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number, index.PropTypes.bool, index.PropTypes.object])
  })).isRequired,

  /** The property to determine styles type for buttons */
  styleType: index.PropTypes.oneOf(['default', 'button']),

  /** A property to determine which validations will be applied to the field */
  syncValidations: index.PropTypes.objectOf(index.PropTypes.string)
};
RadioButtonGroup.displayName = 'RadioButtonGroup';

exports.default = RadioButtonGroup;
//# sourceMappingURL=RadioButtonGroup.js.map
